module.exports = __webpack_public_path__ + "img/logo.7624145c.png";